export const LOAD_PHYSICAL_RELEASES_FILTERS = 'LOAD_PHYSICAL_RELEASES_FILTERS';
export const LOAD_PHYSICAL_SUBMISSIONS_FILTERS =
  'LOAD_PHYSICAL_SUBMISSIONS_FILTERS';
export const LOAD_MERCHANDISE_RELEASES_FILTERS =
  'LOAD_MERCHANDISE_RELEASES_FILTERS';
export const LOAD_MERCHANDISE_SUBMISSIONS_FILTERS =
  'LOAD_MERCHANDISE_SUBMISSIONS_FILTERS';

export interface IProductGrid {
  physicalSubmissionsGridParams?: URLSearchParams | null;
  physicalReleasesGridParams?: URLSearchParams | null;
  merchandiseReleasesGridParams?: URLSearchParams | null;
  merchandiseSubmissionsGridParams?: URLSearchParams | null;
}

export const loadPhysicalReleasesFilters = (
  productGridState: IProductGrid
) => ({
  type: LOAD_PHYSICAL_RELEASES_FILTERS,
  productGridState,
});

export const loadPhysicalSubmissionsFilters = (
  productGridState: IProductGrid
) => ({
  type: LOAD_PHYSICAL_SUBMISSIONS_FILTERS,
  productGridState,
});

export const loadMerchandiseReleasesFilters = (
  productGridState: IProductGrid
) => ({
  type: LOAD_MERCHANDISE_RELEASES_FILTERS,
  productGridState,
});

export const loadMerchandiseSubmissionsFilters = (
  productGridState: IProductGrid
) => ({
  type: LOAD_MERCHANDISE_SUBMISSIONS_FILTERS,
  productGridState,
});
